import React, { FC, useContext, useCallback } from 'react';
import { LabOrderContext } from 'pages/order-flow/lab-order/lab-order-context';
import ProductionScheduling from 'components/shared/production-scheduling/production-scheduling.component';
import { ProductionPlanningStep } from 'models/production-planning';
import { ProductionPlanningProvider } from 'context/production-planning-context';
import { DepartmentsProvider } from 'context/departments-context';

type LabOrderSchedulingSectionProps = {
    onValidChange?: (isValid: boolean) => void;
};

const LabOrderSchedulingSection: FC<LabOrderSchedulingSectionProps> = ({ onValidChange }) => {
    const { order, setOrder } = useContext(LabOrderContext);

    const steps = order.productionPlanningSteps || [];

    const handleProductionPlanChange = useCallback(
        (newSteps: ProductionPlanningStep[]) => {
            setOrder((prev) => ({ ...prev, productionPlanningSteps: newSteps }));
        },
        [setOrder],
    );

    return (
        <ProductionPlanningProvider>
            <DepartmentsProvider>
                <ProductionScheduling
                    steps={steps}
                    onStepsChange={handleProductionPlanChange}
                    internalDeliveryDate={order.internalDeliveryDate}
                    constructions={order.constructions}
                    onValidChange={onValidChange}
                    sampleType={order.sample?.type}
                    clinicId={order.customer?._id}
                />
            </DepartmentsProvider>
        </ProductionPlanningProvider>
    );
};

export default LabOrderSchedulingSection;
